import { Notification, NotificationsResponse } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { parseRequestOptionsToUrlParams } from '../utils';
import HttpClient from '../utils/http/httpClient';
import { RequestOptions } from './requestOptions';

export const getNotifications = (options: RequestOptions<Notification>) =>
  HttpClient.get<NotificationsResponse>(API_FACTORY.v2('notifications'), parseRequestOptionsToUrlParams(options));
